import { useQuery } from '@tanstack/react-query'
import { tagsApi } from '~/entities/tag/api/tags-api'
import { formatTagLabel } from '~/entities/tag/lib/tag-label'
import { QueryKey, queryKey } from '~/shared/lib/query-keys'
import { Badge } from '~/shared/ui/badge'
import { Skeleton } from '~/shared/ui/skeleton'

export function TagBadges({
  categoryId,
  subCategoryIds = [],
}: {
  categoryId?: string
  subCategoryIds?: string[]
}) {
  const { data: allTags = [], isLoading } = useQuery({
    queryKey: queryKey(QueryKey.TAGS),
    queryFn: () => tagsApi.getAll(),
  })

  if (isLoading) return <Skeleton className="h-6 w-40" />

  const category = categoryId ? allTags.find((tag) => tag.id === categoryId) : null
  const subCategories = subCategoryIds.flatMap((id) => allTags.filter((tag) => tag.id === id))
  if (!category && subCategories.length === 0) return null

  return (
    <div className="flex flex-wrap gap-1.5">
      {category && <Badge variant="default">{formatTagLabel(category.name)}</Badge>}
      {subCategories.map((subCategory) => (
        <Badge key={subCategory.id} variant="secondary">
          {formatTagLabel(subCategory.name)}
        </Badge>
      ))}
    </div>
  )
}
